import cn from "classnames";
import { useRouter } from "next/router";
import React, {
  Children,
  FC,
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from "react";

import styles from "./styles.module.css";

type TabNamesType = {
  name: string;
  Icon?:
    | React.FunctionComponent<React.SVGAttributes<SVGElement>>
    | ReactElement;
};

interface TabsProps {
  theme?: "profile" | "default";
  children?: ReactNode;
  tabsNames: TabNamesType[];
  defaultIndex?: number;
  activeTabClassName?: string;
  tabClassName?: string;
  onTabChangeHandle?: any;
  tabsClassName?: string;
  tabsHeaderClasses?: string;
  icons?: any[];
}

const Tabs: FC<TabsProps> = ({
  children,
  tabsNames = [],
  activeTabClassName,
  defaultIndex = 0,
  tabClassName,
  tabsClassName,
  onTabChangeHandle = () => null,
  theme = "default",
  tabsHeaderClasses = "",
}) => {
  const router = useRouter();
  const { defaultTab } = router.query;
  const [openTab, setOpenTab] = useState<number>(defaultIndex);
  const wrapper = useRef<HTMLDivElement>(null);
  useEffect(() => {
    onTabChangeHandle(openTab);
  }, [openTab]);

  useEffect(() => {
    if (defaultTab && typeof defaultTab === "string") {
      setOpenTab(Number(defaultTab));
    }
  }, [defaultTab]);

  return (
    <div
      className={`w-full ${theme == "default" && "transition-all"}`}
      ref={wrapper}
    >
      <div className={`overflow-x-auto pb-1 ${tabsHeaderClasses}`}>
        <div className={`flex ${tabsClassName} border-b-2`}>
          {tabsNames.map(({ name, Icon }, key) => {
            return (
              <div key={key} className={cn(theme == "default" && "flex")}>
                <div
                  key={key}
                  onClick={() => {
                    setOpenTab(key);
                    if (
                      wrapper?.current &&
                      window.scrollY >
                        window.scrollY +
                          wrapper?.current?.getBoundingClientRect().top
                    ) {
                      setTimeout(() => {
                        wrapper?.current?.scrollIntoView({
                          behavior: "smooth",
                        });
                      }, 0);
                    }
                  }}
                  className={cn(
                    tabClassName,
                    key === openTab &&
                      `${activeTabClassName} relative ${styles.active}`,
                    `cursor-pointer ${
                      theme == "default" && "whitespace-nowrap"
                    } `
                  )}
                >
                  {Icon && theme == "profile" ? (
                    <div
                      className={`h-4 rounded-sm px-1 text-white ${
                        key === openTab ? "bg-green-880" : "bg-gray-170"
                      }`}
                    >
                      {Icon && Icon}
                    </div>
                  ) : (
                    Icon
                  )}

                  <p className={`p-3 font-bold ${Icon && "md:mr-4"}`}>{name}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="w-full rounded pt-5">
        {Children.map(children, (Child, key) => {
          if (openTab === key) return <>{Child}</>;
        })}
      </div>
    </div>
  );
};
export default Tabs;
